import React from 'react';
import { Route } from 'react-router-dom';

import Aux from '../../hoc/Aux';
import PublicScreen from '../../containers/PublicScreen/PublicScreen';
import ManagerScreen from '../../containers/ManagerScreen/ManagerScreen';
import ConfigurationScreen from '../../containers/ConfigurationScreen/ConfigurationScreenBase';
import LoginScreen from '../../containers/LoginScreen/LoginScreen';
import ConfigBanned from '../ConfigBanned/ConfigBanned';
import RegisterScreen from '../../containers/RegisterScreen/RegisterScreen';
import ShareScreen from '../../containers/ShareScreen/ShareScreen';
import LogOut from '../../containers/LogOut/LogOut';
import CastScreen from '../../containers/CastScreen/CastScreen';

const layout = () => (
  <Aux>
    <Route path="/" exact component={LoginScreen} />
    <Route path="/logout" exact component={LogOut} />
    <Route path="/pb-screen" exact component={PublicScreen} />
    <Route path="/mg-screen" exact component={ManagerScreen} />
    <Route path="/register" exact component={RegisterScreen} />
    <Route path="/config" exact component={ConfigurationScreen} />
    <Route path="/config/:name" component={ConfigurationScreen} />
    <Route path="/config/banned" exact component={ConfigBanned} />
    <Route path="/sharing" exact component={ShareScreen} />
    <Route path="/cast" exact component={CastScreen} />
  </Aux>
);

export default layout;
